import { apiConfigHelper, locHrefUtil, MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';
import { RSAA } from 'redux-api-middleware';
import { getEcommerceOrderNumber, getOrderDetailsLink, getTenantId } from '../selectors/dealXgDetailsSelectors';
import type { EcommerceOrderReferences } from '@makemydeal/dr-shared-types';
import {
    ECOMMERCE_ORDER_CLEARED,
    REQUEST_CANCEL_ORDER,
    REQUEST_CANCEL_ORDER_FAILURE,
    REQUEST_CANCEL_ORDER_SUCCESS
} from '../types/orders';
import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';
import { createLoggingContextSelector } from '../selectors/loggingContextSelector';
import { SAVE_OFFER_AFTER_CANCEL, SAVE_OFFER_WITH_CANCEL_PENDING } from '../actionTypes/offerActionTypes';
import type { AnyAction, Dispatch } from 'redux';
import type { StateTree } from '@makemydeal/dr-dash-types';
import type { BuildPayloadPurpose } from '@makemydeal/dr-dash-bff-types';

export type CancelOrderCallBack = () => void;

export const getOrderPayload = (state: any): EcommerceOrderReferences => {
    return {
        tenantId: getTenantId(state),
        orderLink: getOrderDetailsLink(state),
        orderNumber: getEcommerceOrderNumber(state)
    };
};
export const getBffEndpoint = (): string => {
    const locHref = locHrefUtil.getLocHref();
    const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(MANAGER_VIEW_APP_PREFIX, locHref, `/commerce/orders/cancel`);
    return bffApiUrlResult.url;
};

export const requestCancelOrder =
    (
        callBack: CancelOrderCallBack,
        payload?: { isCancellingAndSaving?: boolean; purpose?: BuildPayloadPurpose },
        meta?: Record<string, unknown>
    ) =>
    (dispatch: any, getState: any) => {
        const state = getState();
        const orderPayloadBody = getOrderPayload(state);
        const endpoint = getBffEndpoint();

        if (payload?.isCancellingAndSaving) {
            logNewRelicPageAction('MV:Order - Cancelling and Saving', {
                ...createLoggingContextSelector(state),
                isCancellingAndSaving: true
            });
        }

        dispatch({
            [RSAA]: {
                endpoint,
                method: 'PUT',
                body: JSON.stringify(orderPayloadBody),
                headers: {
                    'content-Type': 'application/json'
                },
                types: [
                    REQUEST_CANCEL_ORDER,
                    {
                        type: REQUEST_CANCEL_ORDER_SUCCESS,
                        meta: { callBack }
                    },
                    {
                        type: REQUEST_CANCEL_ORDER_FAILURE,
                        payload,
                        meta
                    }
                ]
            }
        });
    };

/**
 * This action follows the DRY principle by centralizing the logic used in both
 * offerMiddleware and pushToDarwinMiddleware
 */
export const thunkEcommerceCancellationWithSave =
    (payload: { purpose: BuildPayloadPurpose }, meta: Record<string, unknown>) => (dispatch: Dispatch<AnyAction, StateTree>) => {
        // Store the save action details for later resumption
        dispatch({
            type: SAVE_OFFER_WITH_CANCEL_PENDING,
            payload,
            meta
        });

        // Request order cancellation with a callback to resume save
        const resumeSaveCallback = () => {
            dispatch({
                type: SAVE_OFFER_AFTER_CANCEL,
                payload,
                meta
            });
        };

        dispatch(requestCancelOrder(resumeSaveCallback, { isCancellingAndSaving: true, purpose: payload.purpose }, meta));
    };

export const ecommerceOrderCleared = () => ({ type: ECOMMERCE_ORDER_CLEARED });
